import type { JobReportResponse } from "./dto/JobReportDto";
import type { JobReportService } from "@/domain/port/JobReportService";
import type { JobReport } from "@/domain/model/JobReport";
import { HttpClient } from "@/infrastructure/HttpClient";
import { jobReportFromDto } from "./mappers/JobReportMapper";
import type { JobId } from "@/domain/model/Ids";

export class JobReportServiceImpl implements JobReportService {
  constructor(private readonly http: HttpClient) {}

  async getJobReport(jobId: JobId): Promise<JobReport> {
    const resp = await this.http.request<JobReportResponse>(
      `/api/jobs/${jobId}/report`,
      {
        method: "GET",
      },
    );

    try {
      return jobReportFromDto(resp);
    } catch (mappingError) {
      console.error(
        `[DataMapper Error] Failed to parse JobReport ${jobId}`,
        mappingError,
      );
      console.dir(resp);

      throw new Error(`Invalid data received from server for Job ${jobId}`);
    }
  }
}
